import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { hydrate } from "@/lib";

const initialState = {
  isModalOpen: false,
  setUnverifiedDisabledModalOpen: false,
  modalStatus: "cancel",
  clickedButtonStatus: "none",
  triggerPoint: {
    projectId: null,
    toolId: null,
    postId: null,
    action: null,
    triggeredSource: "",
    isTriggeredPointActive: false
  }
};

export const unverifiedModalSlice = createSlice({
  name: "unverifiedModal",
  initialState,
  reducers: {
    setUnverifiedModalOpen: (state, action) => {
      state.isModalOpen = !!action.payload;
    },
    showUnverifiedDisabledModal: (state, action) => {
      state.setUnverifiedDisabledModalOpen = !!action.payload;
    },
    setTriggerPoint: (state, action) => {
      state.triggerPoint = action.payload;
    },
    setModalStatus: (state, action) => {
      state.modalStatus = action.payload;
    },
    setClickedButtonStatus: (state, action) => {
      state.clickedButtonStatus = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(hydrate, (state, action: PayloadAction<string>) => {
      return {
        ...state,
        ...action.payload[unverifiedModalSlice.name]
      };
    });
  }
});

export const {
  setUnverifiedModalOpen,
  showUnverifiedDisabledModal,
  setTriggerPoint,
  setModalStatus,
  setClickedButtonStatus
} = unverifiedModalSlice.actions;
